import React from "react";
import "./rotationalCalendar.scss";
import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
import DescriptionOrbit from "../DescriptionOrbit/DescriptionOrbit";
import ArrowButton from "../../atoms/arrowButton/arrowButton";
import palette from "../../../styles/palette.scss";
import Text from "componets/atoms/text/text";
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const RotationalCalendar = ({ className, textSize, data }) => {
  const days = [
    { title: 1 },
    { title: 3 },
    { title: 4 },
    { title: 11 },
    { title: 21 },
  ];
  const [startingPoint, setStartingPoint] = React.useState(0); // Desde qué lugar empezamos a renderizar los datos
  const [startingPointDays, setStartingPointDays] = React.useState(0); // Desde qué lugar empezamos a renderizar los datos
  const [grades, setGrades] = React.useState([]);
  const [gradesDays, setGradesDays] = React.useState([]);
  React.useEffect(() => {
    if (data && data.length == 1) {
      setGrades([180]);
      setGradesDays([180]);
    }
    if (data && data.length == 2) {
      setGrades([270, 180]);
      setGradesDays([270, 180]);
    }
    if (data && data.length >= 3) {
      setGrades([270, 180, 90]);
      setGradesDays([270, 180, 90]);
    }

    setStartingPointDays(0);
    setStartingPoint(0);
  }, [data]);

  //[0, 45, 90, 135, 180, 225, 270, 315]
  function handleClickDown(
    data,
    setGrades,
    grades,
    setStartingPoint,
    startingPoint
  ) {
    if (
      (startingPoint == data.length - 3 && grades[0] == 360) ||
      !data[startingPoint + 1]
    ) {
    } else if (startingPoint == 0 && grades[2] == 0) {
      let auxGrades = [...grades];
      auxGrades[2] = auxGrades[1] - 90;

      auxGrades.forEach((grade, index) => {
        auxGrades[index] = grade + 90;
      });
      setGrades(auxGrades);
    } else if (startingPoint == data.length - 3) {
      let auxGrades = [...grades];
      auxGrades[0] = 270;
      auxGrades.forEach((grade, index) => {
        auxGrades[index] = grade + 90;
      });
      setGrades(auxGrades);
    } else {
      setStartingPoint(startingPoint + 1);
    }
  }
  function handleClickUp(
    data,
    setGrades,
    grades,
    setStartingPoint,
    startingPoint
  ) {
    if ((startingPoint == 0 && grades[2] == 0) || !data[startingPoint + 2]) {
    } else if (startingPoint == data.length - 3 && grades[0] == 360) {
      let auxGrades = [...grades];
      auxGrades[0] = auxGrades[1] + 90;

      auxGrades.forEach((grade, index) => {
        auxGrades[index] = grade - 90;
      });
      setGrades(auxGrades);
    } else if (startingPoint == 0) {
      let auxGrades = [...grades];
      auxGrades[2] = 90;
      auxGrades.forEach((grade, index) => {
        auxGrades[index] = grade - 90;
      });
      setGrades(auxGrades);
    } else {
      setStartingPoint(startingPoint - 1);
    }
  }
  return (
    <>
      <div
        className={`${className} rotational-calendar__container font-size--${textSize}`}
      >
        <div className="rotational-calendar__buttons-container">
          <ArrowButton
            handleClick={
              days
                ? () =>
                    handleClickUp(
                      days,
                      setGradesDays,
                      gradesDays,
                      setStartingPointDays,
                      startingPointDays
                    )
                : () => {
                    alert("No hay datos por mostrar");
                  }
            }
            type={1}
          />
          <ArrowButton
            handleClick={
              days
                ? () =>
                    handleClickDown(
                      days,
                      setGradesDays,
                      gradesDays,
                      setStartingPointDays,
                      startingPointDays
                    )
                : () => {
                    alert("No hay más datos por mostrar");
                  }
            }
            type={0}
          />
        </div>
        <div className="rotational-calendar__buttons-container rotational-calendar__buttons-container--days">
          <ArrowButton
            handleClick={
              data
                ? () =>
                    handleClickUp(
                      data,
                      setGrades,
                      grades,
                      setStartingPoint,
                      startingPoint
                    )
                : () => {
                    alert("No hay datos por mostrar");
                  }
            }
            type={1}
          />
          <ArrowButton
            handleClick={
              data
                ? () =>
                    handleClickDown(
                      data,
                      setGrades,
                      grades,
                      setStartingPoint,
                      startingPoint
                    )
                : () => {
                    alert("No hay más datos por mostrar");
                  }
            }
            type={0}
          />
        </div>

        <ol className={`rotation-calendar__list`}>
          <div className="rotational-calendar__central-orbit">
            <Text color={palette.darkGreen} type="h" textSize={6}>
              {2021}
            </Text>
          </div>

          {data && data.length >= grades.length ? (
            grades.map((grade, index) => (
              <>
                <DescriptionOrbit
                  percentageSize="100%"
                  isOnCalendar={true}
                  isOnFocus={grade == 180 ? true : false}
                  bgColor={palette.white}
                  color={"black"}
                  key={index}
                  textSize={textSize}
                  rotation={grade}
                  data={data[startingPoint + index]}
                />
              </>
            ))
          ) : (
            <DescriptionOrbit
              isOnCalendar={true}
              isOnFocus={true}
              bgColor={palette.white}
              color={"black"}
              textSize={textSize}
              rotation={180}
              data={{ title: "No se puedieron cargar los datos" }}
            />
          )}

          {days && days.length >= gradesDays.length ? (
            gradesDays.map((grade, index) => (
              <>
                <DescriptionOrbit
                  percentageSize="200%"
                  isOnCalendar={true}
                  isOnFocus={grade == 180 ? true : false}
                  bgColor={palette.white}
                  color={"black"}
                  key={index}
                  textSize={textSize}
                  rotation={grade}
                  data={days[startingPointDays + index]}
                />
              </>
            ))
          ) : (
            <DescriptionOrbit
              isOnCalendar={true}
              isOnFocus={true}
              bgColor={palette.white}
              color={"black"}
              textSize={textSize}
              rotation={180}
              data={{ title: "No se puedieron cargar los datos" }}
            />
          )}
        </ol>
      </div>
    </>
  );
};

export default RotationalCalendar;
